export default function convertToSentence(arr) {
  if (!arr || arr.length === 0) return '';

  const parsedArr = arr.map(word => word.replace(/-/g, ' '));

  if (parsedArr.length === 1) return parsedArr[0];
  if (parsedArr.length === 2) return parsedArr.join(' and ');

  const parsedArrCopy = [...parsedArr];
  const lastWords = parsedArrCopy.splice(parsedArrCopy.length - 2, 2);
  return `${parsedArrCopy.join(', ')}, ${lastWords.join(' and ')}`;
}
